module.exports = __webpack_public_path__ + "img/topbag.276bde73.jpg";